import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Plus, NotebookText } from "lucide-react";
import { toast } from "sonner";

export default function DietPlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/diet-plans"), api.get("/patients")])
      .then(([{ data: pls }, { data: pts }]) => {
        const map = Object.fromEntries(pts.map((p) => [p.user_id, p.name]));
        setPlans(pls.map((pl) => ({ ...pl, patient_name: map[pl.patient_id] || "Patient" })));
      })
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="diet-plans-page">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Diet plans</p>
          <h1 className="text-3xl font-bold mt-1">All diet plans</h1>
        </div>
        <Link to="/diet-plans/new"><Button className="gap-2 rounded-full" data-testid="new-plan-button"><Plus size={16} /> New plan</Button></Link>
      </div>
      {loading ? <div className="text-muted-foreground">Loading…</div> : plans.length === 0 ? (
        <div className="nt-card p-12 text-center text-muted-foreground" data-testid="no-plans">
          <NotebookText size={32} className="mx-auto mb-3 text-primary" />
          <p className="font-semibold">No diet plans yet</p>
        </div>
      ) : (
        <div className="nt-card divide-y divide-border">
          {plans.map((p) => (
            <Link key={p.plan_id} to={`/diet-plans/${p.plan_id}`} className="flex items-center justify-between px-6 py-4 hover:bg-muted transition-colors" data-testid={`diet-plan-row-${p.plan_id}`}>
              <div>
                <div className="font-semibold">{p.name}</div>
                <div className="text-xs text-muted-foreground">{p.patient_name} • {p.plan_type} • {p.days?.length || 0} days {p.active && "• Active"}</div>
              </div>
              <span className="text-xs text-muted-foreground">{p.created_at?.slice(0, 10)}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
